
import s from './blacklist/state'
import * as a from './blacklist/actions'
import * as m from './blacklist/mutations'
import * as g from './blacklist/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
